import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';
import { AccountHeaderItemType } from './account-header-item.model';

export const AccountHeaderResolver: ResolveFn<AccountHeaderItemType[]> = (
  route: ActivatedRouteSnapshot
): AccountHeaderItemType[] => {
  const auraAuthService = inject(AuraAuthService);
  const accountHeaderItems = [] as AccountHeaderItemType[];
  const routePath = route.data?.['path'] ?? '';

  if (auraAuthService.isAuthorized(['view:reporting'])) {
    accountHeaderItems.push({
      name: 'Reports',
      url: 'reporting',
      svgIcon: 'reporting-pillar',
      svgIconHover: 'reporting-pillar-hover',
      selected: routePath === 'reporting',
    });
  }

  if (auraAuthService.isAuthorized(['view:waste-profiling'])) {
    accountHeaderItems.push({
      name: 'Waste Profiles',
      url: 'profiling',
      svgIcon: 'waste-profile-pillar',
      svgIconHover: 'waste-profile-pillar-hover',
      selected: routePath === 'profiling',
    });
  }

  return accountHeaderItems;
};
